import React from "react";

export default function Disclaimer() {
  return (
    <div>
      <div className="third-token-container">
        <p className="list-heading">Disclaimers</p>
        <ol className="list-text">
          <li style={{ fontWeight: "700" }}>
            <div style={{ fontWeight: "300" }}>
              <span className="font-semibold">Non-Refundable:</span> All token purchases are final and non-refundable.
            </div>
          </li>
          <li style={{ fontWeight: "700" }}>
            <div style={{ fontWeight: "300" }}>
              <span className="font-semibold">Expiry:</span> Unused tokens expire 12 months from the date of purchase.
            </div>
          </li>
          <li style={{ fontWeight: "700" }}>
            <div style={{ fontWeight: "300" }}>
              <span className="font-semibold">Non-Transferable:</span> Tokens can only be used by the purchasing consultant.
            </div>
          </li>
        </ol>
      </div>
    </div>
  );
}
